<mat-form-field class="w-full">
    <mat-label><apcam-translation [model]="inputConfig.label" /></mat-label>
    <mat-select
        [formControlName]="formcontrolName"
        [required]="inputConfig.required">
        @for (
            option of inputConfig.options;
            track option.label.translations[defaultLang]
        ) {
            <mat-option [value]="option.label.translations[defaultLang]">
                <apcam-translation [model]="option.label" />
            </mat-option>
        }
    </mat-select>
    @if (input.hasError('required')) {
        <mat-error>
            {{ 'shared.validation.required' | translate }}
        </mat-error>
    }
</mat-form-field>
